import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_GRANSUR_RAK_FEZ } from "@/lib/itineraryHubs";

export default function GransurRakFezHubPage() {
  return <ItineraryHubPage hub={HUB_GRANSUR_RAK_FEZ} />;
}
